import { PromotionPlan } from './Promotion.interface'
import { PaginatedResponse } from './PaginatedResponse.interface'

export interface PlanTranslation {
	id: number
	idLibLanguage: number
	name: string
	description: string
	shortDescription: string | null
}

export interface PlanCountryTranslation {
	name: string
}

export interface PlanCountry {
	id: number
	libCountry: {
		id: number
		translations: PlanCountryTranslation[]
	}
}

export interface PlanContinent {
	id: number
	libContinent: {
		id: number
		description: string
	}
}

export interface PlanSubscriptionType {
	detail: boolean
	id: number
	description: string
}

export interface PlanPaymentType {
	id: number
	description: string
}

export interface Plan {
	active: boolean
	status: number
	statusUpdateDate: string
	id: number
	code: string
	price: number
	numInstallments: number
	forParticular: boolean
	forEnterprise: boolean
	recurrentPayment: boolean
	visible: boolean
	isBar: boolean
	used?: number
	translations: PlanTranslation[]
	planCountries: PlanCountry[]
	planContinents: PlanContinent[]
	libSubscriptionType: PlanSubscriptionType
	libPaymentType: PlanPaymentType
	offerPlans: PromotionPlan[]
}

export type PlanResponse = PaginatedResponse<Plan>

export interface SearchAdvancedPlans {
	applyTypes?: string[]
	offerTypeChooser?: number | null
	page?: number
	size?: number
	active?: boolean
	searchString?: string
	includeBar?: boolean
	includeWithActiveOffers?: boolean
	lightweight?: boolean
}

export enum TypePeriod {
	DAYS = 0,
	MONTHS = 1,
	YEARS = 2
}
